import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";

function Cancel() {
  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col items-center justify-center">
      <Navbar /> {/* Including Navbar component */}
      <div className="text-center mt-20 p-6">
        <h1 className="text-5xl font-bold text-red-600 mb-4">Payment Failed</h1>
        <p className="text-lg text-gray-300 mb-8">
          Unfortunately, your payment could not be processed. Please try again or contact support if the issue persists.
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-3 bg-black text-white font-semibold rounded-lg hover:bg-gray-700 transition duration-200 ease-in-out"
        >
          Return to Home
        </Link>
        <Link
          to="/checkout"
          className="inline-block px-8 py-3 ml-4 bg-gray-700 text-white font-semibold rounded-lg hover:bg-black transition duration-200 ease-in-out"
        >
          Retry Payment
        </Link>
      </div>
    </div>
  );
}

export default Cancel;
